<template>
  <h3
    class="title"
    v-if="block.isShowed('text') && title"
  >
    {{ title }}
  </h3>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from '@/vendors/i18n'

const { block } = defineProps({
  column: { type: Object, required: true },
  block: { type: Object, required: true }
})

const { translate } = useI18n()

const title = computed(() => translate(block.getText()))
</script>

<style  lang="scss" scoped>
.title {
  color: $lg;
  font-size: em(20px);
}
</style>